"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardSelected = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CardArt = require("../../../base-components/CardArt/variants/us-consumer/CardArt");
var _Icon = require("../../../base-components/Icon/Icon");
var _Link = require("../../../base-components/Link/Link");
var _ClickableElement = require("../../../base-components/Button/ClickableElement");
var _Sanitizer = require("../../../base-components/Sanitizer/Sanitizer");
var _MatchHeight = require("../../../utils/MatchHeight");
var _PropertyProvider = require("../../../utils/PropertyProvider/PropertyProvider");
var _svgFetcher = _interopRequireDefault(require("../../../utils/svgFetcher"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// UI COMPONENTS

// UTILITIES

var renderCTA = function renderCTA(links, ctaKey, styles, namespace, linkComponent) {
  var targetLink = ctaKey ? links.find(function (link) {
    return link.key === ctaKey;
  }) : undefined;
  var namespaceVal = 'apply-now';
  if (!targetLink) {
    targetLink = links.find(function (link) {
      return link.key === 'applyNow';
    });
    if (!targetLink) {
      targetLink = links.find(function (link) {
        return link.key === 'speakToSpecialist';
      });
      if (!targetLink) {
        targetLink = links.find(function (link) {
          return link.key === 'modal';
        });
      }
    }
  } else {
    namespaceVal = ctaKey.toLowerCase();
  }
  var hoverText = targetLink && targetLink.hoverText || '';
  return targetLink ? /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    href: targetLink.url,
    dtm: targetLink.dtm,
    className: styles.applyNow,
    title: hoverText,
    namespace: (0, _PropertyProvider.NS)(namespace, namespaceVal),
    Component: linkComponent,
    onClick: targetLink.onClick
  }, targetLink.title) : null;
};
var renderTerms = function renderTerms(links, styles, namespace, linkComponent) {
  var terms = links.find(function (link) {
    return link.key === 'termsAndConditions';
  });
  return terms && /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    href: terms.url,
    dtm: terms.dtm,
    className: styles.tnc,
    target: "_blank",
    namespace: (0, _PropertyProvider.NS)(namespace, 'terms'),
    title: terms.hoverText,
    Component: linkComponent
  }, terms.title);
};
var renderAnnualFee = function renderAnnualFee(card, styles, annualFeeLabel) {
  var annualFee = card && card.annualFeeInline || [];
  var label = annualFeeLabel ? "".concat(annualFeeLabel, " ") : '';
  var annualFeeText = annualFee.length ? "".concat(label).concat(annualFee.map(function (fee) {
    return fee.text;
  }).join(' ')) : '';
  return annualFeeText ? /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    className: styles.annualFeeCopy,
    safelySetInnerHTML: annualFeeText,
    Component: "p"
  }) : null;
};
var renderSupplementalAnnualFee = function renderSupplementalAnnualFee(card, styles) {
  if (!card) {
    return null;
  }
  var suppAnnualFeeItems = Array.isArray(card.suppAnnualFee) ? card.suppAnnualFee : [];
  var suppAnnualFeeText = suppAnnualFeeItems.length ? suppAnnualFeeItems.map(function (fee) {
    return fee.text;
  }).join(' ') : '';
  return /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    className: styles.supplementalAnnualFee,
    safelySetInnerHTML: suppAnnualFeeText,
    Component: "p"
  });
};
var getLearnMoreProps = function getLearnMoreProps(links) {
  return links.find(function (link) {
    return link.key === 'learnMore';
  }) || {};
};
var CardSelected = exports.CardSelected = function CardSelected(_ref) {
  var cardTitle = _ref.cardTitle,
    cardTitleComponent = _ref.cardTitleComponent,
    cardArtUrl = _ref.cardArtUrl,
    cardArtAlt = _ref.cardArtAlt,
    links = _ref.links,
    onLearnMore = _ref.onLearnMore,
    removeCard = _ref.removeCard,
    styles = _ref.styles,
    card = _ref.card,
    iconColor = _ref.iconColor,
    namespace = _ref.namespace,
    indexpos = _ref.indexpos,
    annualFeeLabel = _ref.annualFeeLabel,
    CancelIcon = _ref.CancelIcon,
    linkComponent = _ref.linkComponent;
  var learnMore = getLearnMoreProps(links);
  var annualFee = renderAnnualFee(card, styles, annualFeeLabel);
  var supplementalAnnualFee = renderSupplementalAnnualFee(card, styles);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.selectedCard
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.cardArtContainer
  }, /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    href: learnMore.url,
    className: styles.cardLink,
    dtm: learnMore.dtm,
    namespace: (0, _PropertyProvider.NS)(namespace, 'card-art'),
    title: learnMore.hoverText,
    Component: linkComponent,
    onClick: function onClick() {
      return onLearnMore(card);
    }
  }, /*#__PURE__*/_react["default"].createElement(_CardArt.CardArt, {
    cardArt: cardArtUrl,
    altText: cardArtAlt,
    className: styles.cardArt,
    indexpos: indexpos
  })), /*#__PURE__*/_react["default"].createElement(_ClickableElement.ClickableElement, {
    Component: "span",
    namespace: namespace,
    namespacesuffix: "remove-icon",
    onClick: function onClick() {
      return removeCard(card);
    },
    dtm: card ? card.removeCardDtm : {}
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "remove-card-icon",
    Svg: CancelIcon,
    color: iconColor,
    styles: {
      icon: styles.cancelIcon
    }
  })), /*#__PURE__*/_react["default"].createElement(_MatchHeight.MatchHeight, {
    name: "card-title"
  }, /*#__PURE__*/_react["default"].createElement(_Link.Link, {
    href: learnMore.url,
    className: styles.cardLink,
    dtm: learnMore.dtm,
    namespace: (0, _PropertyProvider.NS)(namespace, 'learn-more'),
    Component: linkComponent,
    onClick: function onClick() {
      return onLearnMore(card);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    className: styles.cardTitle,
    safelySetInnerHTML: cardTitle,
    Component: cardTitleComponent
  }))), (annualFee || supplementalAnnualFee) && /*#__PURE__*/_react["default"].createElement(_MatchHeight.MatchHeight, {
    name: "annual-fee"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.annualFeeContent
  }, renderAnnualFee(card, styles, annualFeeLabel), renderSupplementalAnnualFee(card, styles))), links.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.linksContent
  }, renderCTA(links, card.ctaKey, styles, namespace, linkComponent), renderTerms(links, styles, namespace, linkComponent))));
};
CardSelected.defaultProps = {
  styles: {},
  cardTitle: '',
  cardTitleComponent: 'h2',
  cardArtUrl: '',
  cardArtAlt: '',
  links: [],
  namespace: '',
  indexpos: 0,
  annualFeeLabel: undefined,
  CancelIcon: function CancelIcon() {
    return (0, _svgFetcher["default"])('axp-icon-cancelcircle', 'us-consumer');
  },
  linkComponent: undefined
};
CardSelected.propTypes = {
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    url: _propTypes["default"].string,
    title: _propTypes["default"].string
  })),
  removeCard: _propTypes["default"].func.isRequired,
  annualFeeLabel: _propTypes["default"].string,
  cardTitle: _propTypes["default"].string,
  cardTitleComponent: _propTypes["default"].node,
  cardArtUrl: _propTypes["default"].string,
  cardArtAlt: _propTypes["default"].string,
  card: _propTypes["default"].shape({
    cardTitle: _propTypes["default"].string,
    cardArtUrl: _propTypes["default"].string,
    links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      url: _propTypes["default"].string,
      title: _propTypes["default"].string
    }))
  }).isRequired,
  iconColor: _propTypes["default"].string.isRequired,
  namespace: _propTypes["default"].string,
  onLearnMore: _propTypes["default"].func.isRequired,
  indexpos: _propTypes["default"].number,
  CancelIcon: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  linkComponent: _propTypes["default"].func
};